/* eslint-disable */
require('./icon_arrow-up')
require('./icon_menu-close')
require('./icon_menu')



// WEBPACK FOOTER //
// ./src/compiled-icons/index.js